export default "__VITE_ASSET__BrSQfRIr__"